import { render, staticRenderFns } from "./MarketingSetting.vue?vue&type=template&id=4d246087&scoped=true"
import script from "./MarketingSetting.vue?vue&type=script&lang=js"
export * from "./MarketingSetting.vue?vue&type=script&lang=js"
import style0 from "./MarketingSetting.vue?vue&type=style&index=0&id=4d246087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d246087",
  null
  
)

export default component.exports